import Button from "@components/AccessibleComponents/Button";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LambdaResponsePayload } from "@pages/Article/types/Alacrity";

import ArticleSubshareGifterAction from "./Modal/Actions/Actions";
import ArticleSubshareGifterHeader from "./Modal/Header";
import ArticleSubshareGifterIcon from "./Modal/Icon";
import ArticleSubshareGifterMessage from "./Modal/Messages/Messages";

export type ArticleSubshareReceivedProps = {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  alacrityRes: LambdaResponsePayload;
};

export default function ArticleSubshareReceived({
  setIsModalOpen,
  alacrityRes,
}: ArticleSubshareReceivedProps) {
  return (
    <>
      <Button
        className="absolute right-4 top-4"
        onPress={() => {
          setIsModalOpen(false);
        }}
      >
        <FontAwesomeIcon icon={faXmark} size="xl" />
      </Button>

      <div className="flex flex-col items-center p-5 py-10">
        <ArticleSubshareGifterIcon {...alacrityRes} />

        <ArticleSubshareGifterHeader {...alacrityRes} />

        <ArticleSubshareGifterMessage {...alacrityRes} />

        <ArticleSubshareGifterAction
          {...alacrityRes}
          setIsModalOpen={setIsModalOpen}
        />
      </div>
    </>
  );
}
